import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Header from "../components/Header";
import Layout from "../components/Layout";
import styled, { keyframes } from "styled-components";
import Drawer from "../components/Drawer";
import { useState } from "react";
import Accordion from "react-bootstrap/Accordion";
import BigQuestion from "../components/BigQuestion";
import SmallQuestion from "../components/SmallQuestion";
import {
  deleteQuestion,
  getQuestions,
  searchQuestion,
} from "../actions/questionActions";
import Search from "../components/Search";
import { QUERIES } from "../contants/allConstants";
import { COLORS } from "../contants/colors";
import Miniheader from "../components/Miniheader";
import Nav from "react-bootstrap/Nav";
import ResponsiveTable from "../components/ResponsiveTable";
import UserDetails from "../components/UserDetails";
import Pagination from "react-responsive-pagination";
import "bootstrap/dist/css/bootstrap.min.css";
import AgeStatistics from "../components/AgeStatistics";
import CustomPieChart from "../components/CustomPieChart";
import CitiesChart from "../components/CitiesChart";
import BelongChart from "../components/BelongChart";
import ToastContainer from "react-bootstrap/esm/ToastContainer";
import Collapse from "react-bootstrap/Collapse";
import Toast from "react-bootstrap/Toast";
import { useLanguageContext } from "../languageContext";
import moment from "moment";
import fr from "moment/locale/fr";
import it from "moment/locale/it";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import * as htmlToImage from "html-to-image";

const QuestionsScreen = ({ history }) => {
  const dispatch = useDispatch();
  const { questions } = useSelector((state) => state.question);
  const { userInfo } = useSelector((state) => state.userLogin);
  const [selected, setSelected] = useState(1);
  const [keyword, setKeyword] = useState("");
  const [openDrawer, setOpenDrawer] = useState(false);
  const [selectedQues, setSelectedQues] = useState(null);
  const [selectedAnswer, setSelectedAnsw] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [active, setActive] = useState(1);
  const [limit, setLimit] = useState(3);
  const [users, setUsers] = useState([]);
  const [next, setNext] = useState(1);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [message, setMessage] = useState("");
  const [toastType, setToastType] = useState("");
  const { t } = useLanguageContext();
  const [loading, setLoading] = useState(false);



  useEffect(() => {
    const lang = JSON.parse(localStorage.getItem("langAnisso")).lang;
    if (lang === "fr") {
      moment.locale("fr", fr);
    } else if (lang === "it") {
      moment.locale("it", it);
    } else moment.locale("en");
    dispatch(getQuestions(userInfo["token"]));
  }, []);

  useEffect(() => {
    if (selectedAnswer) {
      pageClick(1, selectedAnswer?.users);
    }
  }, [selectedAnswer]);

  const onSearchQuestions = () => {
    dispatch(searchQuestion(userInfo["token"], keyword, startDate, endDate));
  };
  const onDeleteQuestion = (id) => {
    dispatch(deleteQuestion(userInfo["token"], id));
  };

  const pageClick = async (pageNumber, users) => {
    pageNumber = pageNumber <= 0 ? 1 : pageNumber;
    const payload = users.slice((pageNumber - 1) * limit, pageNumber * limit);
    setUsers(payload);
    setActive(pageNumber);
    if (pageNumber >= next + 6) setNext(next + 1);
    if (pageNumber !== 1 && pageNumber <= next) setNext(next - 1);
  };

  useEffect(() => {
    if (keyword !== "" || startDate !== "" || endDate !== "") {
      onSearchQuestions();
    }
    if (keyword === "" && startDate === "" && endDate === "") {
      dispatch(getQuestions(userInfo["token"]));
      setActive(1);
    }
  }, [keyword, startDate, endDate]);


  const printDocument = async () => {
    setLoading(true);
    const wrapper = document.getElementById("divToPrint");

    // Store original styles and states
    const originalStyles = {
      overflow: wrapper.style.overflow,
      height: wrapper.style.height,
    };

    // Expand all accordions
    const accordions = wrapper.querySelectorAll(".accordion-collapse");
    const originalAccordionStates = Array.from(accordions).map((a) =>
      a.classList.contains("show")
    );
    accordions.forEach((a) => a.classList.add("show"));

    // Set fixed height for each accordion body
    const accordionBodies = wrapper.querySelectorAll(".accordion-body");
    accordionBodies.forEach((body) => {
      // body.style.minHeight = "400px";
      body.style.overflow = "visible";
    });

    // Show all tab content
    const tabs = wrapper.querySelectorAll(".tab-export");

    const originalTabDisplay = Array.from(tabs).map((tab) => tab.style.display);
    tabs.forEach((tab) => {
      tab.style.display = "block";
    });
    //hide tab titles
    const tabTitles = wrapper.querySelectorAll(".nav-title");
    tabTitles.forEach((title) => {
      title.style.position = "absolute";
      title.style.zIndex = -1;
    });

    // Make container scrollable temporarily
    wrapper.style.overflow = "visible";
    wrapper.style.height = "auto";

    // Wait for layout to stabilize
    await new Promise((resolve) => setTimeout(resolve, 300));

    try {
      const pdf = new jsPDF("p", "mm", "a4");

      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();

      //add question details
      const print_question = wrapper.querySelector(".printQuestion");
      // Generate image
      const questionUrl = await htmlToImage.toPng(print_question, {
        quality: 1,
        backgroundColor: "#ffffff",
        width: print_question.scrollWidth,
        height: print_question.scrollHeight,
      });
      const qProps = pdf.getImageProperties(questionUrl);
      const scale = (pageWidth / qProps.width) * 1.2;
      const qHeight = qProps.height * scale;
      let position = 0;
      let heightLeft = qHeight;
      // First page
      pdf.addImage(questionUrl, "PNG", 0, position, pageWidth, qHeight);
      heightLeft -= pageHeight;
      while (heightLeft > 0) {
        position -= pageHeight;
        pdf.addPage();
        pdf.addImage(questionUrl, "PNG", 0, position, pageWidth, qHeight);
        heightLeft -= pageHeight;
      }
      //  pdf.addPage();

      for (let i = 0; i < tabs.length; i++) {
        const tab = tabs[i];

        // Add title for this tab
        const title = tab.querySelector(".nav-title-acc");
        const titleClone = title ? title.cloneNode(true) : null;

        if (titleClone) {
          titleClone.style.visibility = "visible";
          titleClone.style.position = "static";
          tab.insertBefore(titleClone, tab.firstChild);
        }

        // Wait for rendering updates
        await new Promise((res) => setTimeout(res, 300));

        // Generate image for this tab
        const dataUrl = await htmlToImage.toPng(tab, {
          quality: 1,
          backgroundColor: "#ffffff",
          width: tab.scrollWidth,
          height: tab.scrollHeight,
        });

        const imgProps = pdf.getImageProperties(dataUrl);
        const scale = pageWidth / imgProps.width;
        const imgHeight = imgProps.height * scale;

        let position = 0;
        let heightLeft = imgHeight;

        // First page
        pdf.addImage(dataUrl, "PNG", 0, position, pageWidth, imgHeight);
        heightLeft -= pageHeight;

        while (heightLeft > 0) {
          position -= pageHeight;
          pdf.addPage();
          pdf.addImage(dataUrl, "PNG", 0, position, pageWidth, imgHeight);
          heightLeft -= pageHeight;
        }

        if (i < tabs.length - 1) pdf.addPage();

        // Remove clone
        if (titleClone) tab.removeChild(titleClone);
      }

      pdf.save("anisso.pdf");

    } catch (error) {

      console.error("Error generating PDF:", error);
    } finally {
      // Restore all states and styles
      accordions.forEach((a, i) => {
        if (!originalAccordionStates[i]) a.classList.remove("show");
      });

      accordionBodies.forEach((body) => {
        body.style.overflow = "";
      });

      tabs.forEach((tab, i) => {
        tab.style.display = originalTabDisplay[i];
      });

      tabTitles.forEach((title) => {
        title.style.position = "initial";
        title.style.zIndex = "10000";
      });

      wrapper.style.overflow = originalStyles.overflow;
      wrapper.style.height = originalStyles.height;
      setLoading(false);

    }
  };

  return (
    <>
      {selectedUser && (
        <UserDetails
          user={selectedUser}
          onClose={() => setSelectedUser(null)}
        />
      )}

      <Layout>
        <Header
          onClickNotification={(user) => setSelectedUser(user)}
           setOpenDrawer={() => setOpenDrawer(!openDrawer)} />
        <Drawer
          setOpenDrawer={() => setOpenDrawer(!openDrawer)}
          open={openDrawer}
          history={history}
          selected={selected}
          onChange={(value) => setSelected(value)}
        />
        {selectedQues ? (
          <div>      {loading && <LoaderWrapper>
            <Spinner />
          </LoaderWrapper>}

          <DetailsBody>
            <Miniheader
              title={t("questionDetails")}
              arrow={true}
              pdf={true}
              goBack={() => setSelectedQues(null)}
              onExport={() => printDocument()}
            />
            <Wrapper id="divToPrint">
              <div
                className="printQuestion"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <Title>{selectedQues["title"]}</Title>

                <Subtitle>{selectedQues["description"]}</Subtitle>
                {selectedQues.media === "" ? null : selectedQues.media.includes(
                    ".mp3"
                  ) || selectedQues.media.includes(".wav") ? (
                  <Audio controls src={selectedQues.media}></Audio>
                ) : selectedQues.media.includes(".png") ||
                  selectedQues.media.includes(".jpeg") ||
                  selectedQues.media.includes(".jpg") ? (
                  <Photo
                  crossOrigin="anonymous"
                    src={
                      selectedQues.media !== ""
                        ? selectedQues.media
                        : require("../images/placeholder.svg").default
                    }
                  />
                ) : (
                  <VideoPreview
                    width="85%"
                    height="85%"
                    controls
                    key={selectedQues.media}
                  >
                    <source
                      src={selectedQues.media}
                      type="video/mp4"
                      key={selectedQues.media}
                    />
                  </VideoPreview>
                )}
              </div>
              <Nav
                fill
                variant="tabs"
                defaultActiveKey="link-1"
                className="tab-export"
              >
                {selectedQues.answers.map((a, i) => (
                  <Nav.Item className={`Tab${i}`}>
                    <Nav.Link
                      eventKey={`link-${i + 1}`}
                      onClick={() => setSelectedAnsw(a)}
                      className="nav-title"
                    >
                      <Result>
                        <p>
                          {" ("}
                          {a.users.length}
                          {") "}
                          {t("answer")}'
                        </p>
                        <strong>{a.description}</strong>
                        <p>'</p>
                      </Result>
                    </Nav.Link>
                  </Nav.Item>
                ))}
              </Nav>
              {selectedQues.answers.map((answer, index) => (
                <div
                  className="tab-export"
                  data-answer-index={index}
                  style={{
                    display:
                      selectedAnswer?.description === answer.description
                        ? "block"
                        : "none",
                  }}
                >
                  <Unvisible className="nav-title-acc">
                    <p>
                      {" ("}
                      {answer.users.length}
                      {") "}
                      {t("answer")}'
                    </p>
                    <strong>{answer.description}</strong>
                    <p>'</p>
                  </Unvisible>
                  {answer.users.length > 0 ? (
                    <StatisticsBody>
                      <Accordion>
                        <Accordion.Item eventKey={answer.description + "0"}>
                          <Accordion.Header>{t("dependAge")}</Accordion.Header>
                          <Accordion.Body>
                            <AgeStatistics users={answer?.users} />
                          </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey={answer.description + "1"}>
                          <Accordion.Header>
                            {t("dependCountry")}
                          </Accordion.Header>
                          <Accordion.Body>
                            <CustomPieChart
                              users={answer?.users}
                              field={"country"}
                              color={"#f77847"}
                            />
                          </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey={answer.description + "2"}>
                          <Accordion.Header>
                            {t("dependState")}
                          </Accordion.Header>
                          <Accordion.Body>
                            <CitiesChart users={answer?.users} />
                          </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey={answer.description + "4"}>
                          <Accordion.Header>
                            {t("dependGender")}
                          </Accordion.Header>
                          <Accordion.Body>
                            <CustomPieChart
                              users={answer?.users}
                              field={"gender"}
                              color={"#f77847"}
                            />
                          </Accordion.Body>
                        </Accordion.Item>
                      </Accordion>
                    </StatisticsBody>
                  ) : (
                    <EmptyAnswers>{t("noAnswers")}</EmptyAnswers>
                  )}
                </div>
              ))}
            </Wrapper>
          </DetailsBody>
          </div>
        ) : (
          <Body>
            <Search
              hint={t("search")}
              dropdownTitle={t("state")}
              showDelete={false}
              states={[]}
              onSearch={() => {
                if (keyword !== "") {
                  onSearchQuestions();
                } else if (startDate !== "" || endDate !== "") {
                  onSearchQuestions();
                }
              }}
              onChange={(value) => {
                setKeyword(value);
              }}
              onChangeEndDate={(value) => {
                if (!isNaN(new Date(value).getDate())) {
                  if (new Date(value) <= new Date(startDate)) {
                    setMessage(t("startGt"));
                    setToastType("danger");
                  } else setEndDate(new Date(value));
                }
              }}
              onChangeStartDate={(value) => {
                if (!isNaN(new Date(value).getDate())) {
                  if (new Date(value) >= new Date(endDate)) {
                    setMessage(t("startLt"));
                    setToastType("danger");
                  } else setStartDate(new Date(value));
                }
              }}
              onClearFilters={() => {
                setStartDate("");
                setEndDate("");
              }}
            />
            {questions.length === 0 && <Empty>{t("emptyQ")}</Empty>}

            {questions[0] && (
              <BigQuestion
                question={questions[0]}
                onDelete={(id) => onDeleteQuestion(id)}
                onClick={() => {
                  setSelectedQues(questions[0]);
                  if (questions[0].answers[0])
                    setSelectedAnsw(questions[0].answers[0]);
                }}
              />
            )}
            <Grid>
              {questions.map((question, index) => {
                return index !== 0 ? (
                  <SmallQuestion
                    index={index + 1}
                    question={question}
                    onDelete={(id) => onDeleteQuestion(id)}
                    onClick={() => {
                      setSelectedQues(question);
                      if (question.answers[0])
                        setSelectedAnsw(question.answers[0]);
                    }}
                  />
                ) : null;
              })}
            </Grid>
            {toastType !== "" && (
              <ToastContainer
                containerPosition="sticky"
                position="top-end"
                style={{
                  position: "fixed !important",
                  bottom: "40%",
                  right: 0,
                  zIndex: "2000",
                  float: "right",
                  textAlign: "left",
                }}
              >
                <Toast
                  delay={7000}
                  animation
                  transition={Collapse}
                  bg={toastType}
                  style={{
                    borderRadius: "4px",
                    fontFamily: "Din",
                    padding: "0 30px",
                  }}
                >
                  <Toast.Body className={"text-white"}>{message}</Toast.Body>
                </Toast>
              </ToastContainer>
            )}
          </Body>
        )}
      </Layout>
    </>
  );
};

const Body = styled.div`
  padding: 3vw 40px;
`;
const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  justify-content: end;
  grid-gap: 20px;
  margin-top: 25px;
`;
const Empty = styled.p`
  color: ${COLORS.gray400};
  font-family: "Din";
  font-weight: 400;
  font-size: 0.9rem;
  text-align: center;
  align-self: center;
  margin-top: 20vh;
`;
const EmptyAnswers = styled.p`
  color: ${COLORS.gray400};
  font-family: "Din";
  font-weight: 400;
  font-size: 0.9rem;
  text-align: center;
  align-self: center;
  padding: 30px 0;
  background-color: #3472670e;
`;
const DetailsBody = styled.div`
  padding: 3vw 4vw;
  position: relative;
  overflow-x: hidden;
`;
const Wrapper = styled.div`
  background-color: white;
  padding: 20px 40px;
  font-family: "Din";
  font-size: 1rem;
  @media (${QUERIES.mobileAndDown}) {
    padding: 10px;
  }
`;

const Title = styled.div`
  font-weight: 600;
  font-size: 1.2rem;
  padding-top: 10px;
  text-align: center;
  margin-bottom: 10px;
`;
const Subtitle = styled.div`
  font-weight: 500;
  text-align: center;
  margin-bottom: 12px;
`;
const Result = styled.div`
  display: flex;
  font-weight: 400;
  padding-top: 13px;
  // text-align: left;
  max-width: 27vw;
  word-wrap: break-word;
  @media (${QUERIES.mobileAndDown}) {
    max-width: 70vw;
  }
`;
const Unvisible = styled.div`
  visibility: hidden;
  display: flex;
  justify-content: center;
  font-size: 1.2rem;
  font-weight: 400;
  padding: 0 !important;
  text-align: center;
  width: 100%;
  word-wrap: break-word;
  margin-top: 20px;
  @media (${QUERIES.mobileAndDown}) {
    max-width: 70vw;
  }
`;
const Row = styled.div`
  display: flex;
  justify-content: space-evenly;
  padding: 0;
  @media (${QUERIES.mobileAndDown}) {
    flex-direction: column;
  }
`;
const StatisticsBody = styled.div`
  padding: 0 20px;
  background-color: #3472670e;
`;
const Audio = styled.audio`
  width: 100%;
  /* height: 70%; */
  background-color: #f1f3f4;
  border-radius: 4px;
  margin: 20px 0 7px 0;
  border: 1px solid #ccc;
`;
const VideoPreview = styled.video`
  width: 100%;
  height: 25vh;
  margin: 29px 0 7px 0;
  object-fit: cover;
  vertical-align: middle;
  border-radius: 4px;
`;
const Photo = styled.img`
  border-radius: 4px;
  margin: 29px 0 7px 0;
  height: 35vh;
  max-height: 250px;
  width: 100%;
  max-width: 700px;
  object-fit: cover;
`;

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const LoaderWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(255, 255, 255, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
`;

const Spinner = styled.div`
  border: 6px solid #ccc;
  border-top: 6px solid #007bff;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: ${spin} 1s linear infinite;
`;
export default QuestionsScreen;
